import { render } from "./RoadPricesView.vue?vue&type=template&id=7a79c1a2&scoped=true"
import script from "./RoadPricesView.vue?vue&type=script&lang=js"
export * from "./RoadPricesView.vue?vue&type=script&lang=js"

import "./RoadPricesView.vue?vue&type=style&index=0&id=7a79c1a2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a79c1a2"]])

export default __exports__